import firebase from "firebase/app";
import 'firebase/firestore';
import filterPublic from "@/store/modules/utils/filterPublic";

const firestore = firebase.firestore;

const COLLECTION_COMPANIES = process.env.VUE_APP_COLLECTION_COMPANIES;

export default {
    namespaced: true,
    state: {
        companies: [],
        lastVisible: null
    },
    getters: {
        getCompanies: state => state.companies
    },
    mutations: {
        SET_COMPANY(state, companies) {
            state.companies = companies;
        },
        SET_LAST_VISIBLE(state, value) {
            state.lastVisible = value;
        },
        ADD_COMPANY(state, company) {
            state.companies.push(company);
        },
        UPDATE_COMPANY(state, payload) {
            Object.assign(state.companies[payload.index], payload.company);
        },
        REMOVE_COMPANY(state, company) {
            state.companies = state.companies.filter(item => item.id !== company.id);
        }
    },
    actions: {
        async addCompany({commit}, company) {
            const docRef = await firestore().collection(COLLECTION_COMPANIES).add(company);
            company.id = docRef.id;
            commit('ADD_COMPANY', company);
        },
        async searchCompanies({commit}, query) {
            const processedQuery = query.search.toLowerCase().replace(/[^a-z0-9čšćđž]/g, ' ').split(/[ -]+/).filter(str => {
                return str.length > 1;
            });

            const querySnapshot = query.type !== 'All'
                ? await firestore().collection(COLLECTION_COMPANIES)
                    .where('keywords', 'array-contains-any', processedQuery)
                    .where('javna', '==', query.type === 'Public')
                    .get()
                : await firestore().collection(COLLECTION_COMPANIES)
                    .where('keywords', 'array-contains-any', processedQuery)
                    .get();

            const companies = querySnapshot.docs.map(doc => {
                const company = doc.data();
                company.id = doc.id;
                return company;
            });

            companies.sort((a, b) => intersection(processedQuery, b.keywords).length - intersection(processedQuery, a.keywords).length);
            commit('SET_COMPANY', companies);

            function intersection(first, second) {
                first = new Set(first);
                second = new Set(second);
                return [...first].filter(item => second.has(item));
            }
        },
        async loadCompanies({commit, state}, params) {
            const { orderBy, refreshPage, itemsPerPage, companyType } = params;

            const first = refreshPage
                ? firestore().collection(COLLECTION_COMPANIES)
                    .orderBy(...orderBy)
                    .limit(refreshPage ? itemsPerPage * 2 : itemsPerPage)
                : firestore().collection(COLLECTION_COMPANIES)
                    .orderBy(...orderBy)
                    .startAfter(state.lastVisible)
                    .limit(refreshPage ? itemsPerPage * 2 : itemsPerPage)

            const querySnapshot = await first.get().then(snapshot => {
                const lastVisible = snapshot.docs[snapshot.docs.length - 1];
                commit('SET_LAST_VISIBLE', lastVisible);
                return snapshot;
            });
            const companies = querySnapshot.docs.map(doc => {
                const company = doc.data();
                company.id = doc.id;
                return company;
            });

            if (refreshPage) {
                commit('SET_COMPANY', filterPublic(companies, companyType));
            } else {
                commit('SET_COMPANY', filterPublic([...state.companies, ...companies], companyType));
            }
        },
        async updateCompany({commit}, payload) {
            await firestore().collection(COLLECTION_COMPANIES).doc(payload.company.id).set(payload.company);
            commit('UPDATE_COMPANY', payload);
        },
        async removeCompany({commit}, company) {
            await firestore().collection(COLLECTION_COMPANIES).doc(company.id).delete();
            commit('REMOVE_COMPANY', company);
        }
    }
}
